async function captureForm({
  apiKey,
  recipientEmail,
  templateId,
  email,
  firstName,
  lastName,
  phone = '',
  message = ''
}) {
  try {
    const payload = {
      apiKey,
      recipientEmail,
      templateId,
      email,
      firstName,
      lastName,
      phone,
      message
    };
    
    const response = await fetch('https://addition.zerosoftwares.com/brevo-proxy.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Failed to send email');
    }
    
    return result;
  } catch (error) {
    console.error('Email error:', error);
    return { success: false, error: error.message };
  }
}

if(document.querySelector('#almaCollectionSwiper')){
    // ALMA Collection Swiper
    const almaCollectionSwiper = new Swiper('#almaCollectionSwiper', {
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 1,
        loop: true,
        navigation: {
            nextEl: '.alma-swiper-button-next',
            prevEl: '.alma-swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 25,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 30,
            }
        }
    });
    
}


const searchToggle = document.querySelector('.search-button');
const searchOverlay = document.getElementById('searchOverlay');
const searchInput = document.getElementById('searchInput');
const searchContainer = document.querySelector('.search-container');

const cartNotesHeader = document.getElementById('cartNotesHeader');
const cartNotesToggle = document.getElementById('cartNotesToggle');

// Function to initialize Swiper slider
function initSwiperSlider(containerId, paginationSelector, nextSelector, prevSelector) {
    const swiperContainer = document.querySelector(containerId);
    if (!swiperContainer) return;
    
    const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
    if (!swiperWrapper) return;
    
    // Get configuration from data attributes
    const autoplayDelay = swiperWrapper.getAttribute('data-swiper-autoplay');
    const effect = swiperWrapper.getAttribute('data-swiper-effect');
    const speed = swiperWrapper.getAttribute('data-swiper-speed');
    
    // Build Swiper configuration
    let swiperConfig = {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: speed ? parseInt(speed) : 500,
        pagination: {
            el: paginationSelector,
            clickable: true,
        },
        navigation: {
            nextEl: nextSelector,
            prevEl: prevSelector,
        },
    };
    
    // Add effect if specified and not 'none'
    if (effect && effect !== 'none') {
        swiperConfig.effect = effect;
        
        // Add effect-specific options for certain effects
        if (effect === 'cube') {
            swiperConfig.cubeEffect = {
                shadow: true,
                slideShadows: true,
                shadowOffset: 20,
                shadowScale: 0.94,
            };
        } else if (effect === 'flip') {
            swiperConfig.flipEffect = {
                slideShadows: true,
                limitRotation: true,
            };
        } else if (effect === 'coverflow') {
            swiperConfig.coverflowEffect = {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
            };
        } else if (effect === 'cards') {
            swiperConfig.cardsEffect = {
                perSlideOffset: 8,
                perSlideRotate: 2,
                rotate: true,
                slideShadows: true,
            };
        } else if (effect === 'creative') {
            swiperConfig.creativeEffect = {
                prev: {
                    shadow: true,
                    translate: [0, 0, -400],
                },
                next: {
                    translate: ['100%', 0, 0],
                },
            };
        }
    }
    
    // Add autoplay if enabled (delay > 0)
    if (autoplayDelay && parseInt(autoplayDelay) > 0) {
        swiperConfig.autoplay = {
            delay: parseInt(autoplayDelay),
            disableOnInteraction: false,
        };
    }
    
    return new Swiper(containerId, swiperConfig);
}

// Initialize Intro Media Container
if(document.querySelector('#introMediaContainer')){
    initSwiperSlider('#introMediaContainer', '.swiper-pagination', '.swiper-button-next', '.swiper-button-prev');
}

document.addEventListener('DOMContentLoaded', function () {
    // Initialize Hero Swiper Container
    if(document.querySelector('#heroSwiperContainer')){
        initSwiperSlider('#heroSwiperContainer', '.hero-pagination', '.hero-button-next', '.hero-button-prev');
    }
    
    initSearch();
    initAccordion();
    initCartNote();
    // initMobileMenu();

    // Initialize product filters if filters exist on page
    const filtersToggle = document.getElementById('filtersToggle');
    if (filtersToggle) {
        new ProductFilters();
    }
});

const openSearch = () => {
    searchOverlay.classList.add('active');
    document.body.classList.add('search-open');
    // Focus on search input after animation
    setTimeout(() => {
        searchInput.focus();
    }, 300);
}

const closeSearch = () =>{
    searchOverlay.classList.remove('active');
    document.body.classList.remove('search-open');
    searchInput.value = '';
}

const isSearchOpen = () =>{
    return searchOverlay.classList.contains('active');
}
const initAccordion = ()=>{
    const accordionHeaders = document.querySelectorAll('.accordion-header');

    if (accordionHeaders.length > 0) {
        const firstHeader = accordionHeaders[0];
        const firstTargetId = firstHeader.getAttribute('data-target');
        const firstContent = document.getElementById(firstTargetId);

        firstHeader.classList.add('active');
        firstContent.classList.add('active');
    }

    accordionHeaders.forEach(header => {
        header.addEventListener('click', function () {
            const targetId = this.getAttribute('data-target');
            const content = document.getElementById(targetId);
            const arrow = this.querySelector('.accordion-arrow');

            accordionHeaders.forEach(otherHeader => {
                if (otherHeader !== this) {
                    const otherTargetId = otherHeader.getAttribute('data-target');
                    const otherContent = document.getElementById(otherTargetId);
                    const otherArrow = otherHeader.querySelector('.accordion-arrow');

                    otherHeader.classList.remove('active');
                    otherContent.classList.remove('active');
                }
            });

            if (this.classList.contains('active')) {
                this.classList.remove('active');
                content.classList.remove('active');
            } else {
                this.classList.add('active');
                content.classList.add('active');
            }
        });
    });

    const faqHeaders = document.querySelectorAll('.faq-header');

    // Make the first FAQ item open by default
    if (faqHeaders.length > 0) {
        const firstFaqHeader = faqHeaders[0];
        const firstFaqTargetId = firstFaqHeader.getAttribute('data-faq-target');
        const firstFaqContent = document.getElementById(firstFaqTargetId);

        if (firstFaqContent) {
            firstFaqHeader.classList.add('faq-active');
            firstFaqContent.classList.add('faq-active');
        }
    }

    faqHeaders.forEach(header => {
        header.addEventListener('click', function () {
            const targetId = this.getAttribute('data-faq-target');
            const content = document.getElementById(targetId);

            faqHeaders.forEach(otherHeader => {
                if (otherHeader !== this) {
                    const otherTargetId = otherHeader.getAttribute('data-faq-target');
                    const otherContent = document.getElementById(otherTargetId);

                    otherHeader.classList.remove('faq-active');
                    otherContent.classList.remove('faq-active');
                }
            });

            if (this.classList.contains('faq-active')) {
                this.classList.remove('faq-active');
                content.classList.remove('faq-active');
            } else {
                this.classList.add('faq-active');
                content.classList.add('faq-active');
            }
        });
    });
}

 const toggleCartNotes = () => {
        const cartNotesContent = document.getElementById('cartNotesContent');
        const isExpanded = cartNotesContent.classList.contains('expanded');
        
        if (isExpanded) {
            // Collapse
            cartNotesContent.classList.remove('expanded');
            cartNotesToggle.classList.remove('expanded');
            cartNotesToggle.textContent = '+';
        } else {
            // Expand
            cartNotesContent.classList.add('expanded');
            cartNotesToggle.classList.add('expanded');
            cartNotesToggle.textContent = '−';
        }
    }
const initCartNote = ()=>{
 // Toggle cart notes
 //cartNotesHeader && cartNotesHeader.addEventListener('click', () => toggleCartNotes());

}
const initSearch = ()=>{
    // console.log('searchToggle',searchToggle)
    // console.log('openSearch',openSearch)
    if(searchOverlay){
        // Close cart/search on escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                if (isSearchOpen()) {
                    closeSearch();
                }
            }
        });
        
         // Search functionality
        // searchToggle.addEventListener('click', openSearch);
        
        // Close search when clicking close button
        const searchClose = document.getElementById('searchClose');
        if (searchClose) {
            searchClose.addEventListener('click', closeSearch);
        }
        
        // Close search when clicking outside the search container
        searchOverlay.addEventListener('click', (e) => {
            if (!searchContainer.contains(e.target)) {
                closeSearch();
            }
        });
    }
}

const initMobileMenu = ()=>{

    const navContainer = document.querySelector('.nav-main-container');
    const navLogo = document.querySelector('.logo img');
    const mobileMenuIcon = document.querySelector('.mobile-menu-toggle .menu-icon');

    if (navContainer && navLogo) {
        let lastScrollTop = 0;
        let hasScrolledDown = false;
        let ticking = false;

        // Define logo URLs with fallbacks
        const defaultLogo = `//addition.life/cdn/shop/files/nav-logo.svg?v=1759569011&width=350`;
        const stickyLogo = `//addition.life/cdn/shop/files/nav-logo-black.svg?v=1759568996&width=350`;

        function updateNavigation() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            // Immediate reset when at very top (no animation)
            if (scrollTop === 0) {
                navContainer.style.transition = 'none';
                navContainer.classList.remove('nav-sticky', 'nav-hidden');
                navContainer.parentElement.classList.remove('nav-sticking');
                navLogo.src = defaultLogo;
                if (mobileMenuIcon) {
                    mobileMenuIcon.src = `//addition.life/cdn/shop/t/27/assets/hamburger-white.svg?v=28940738419301439421775130023`;
                }
                hasScrolledDown = false;
                // Restore transition after immediate change
                setTimeout(() => {
                    navContainer.style.transition = '';
                }, 0);
                lastScrollTop = scrollTop;
                ticking = false;
                return;
            }

            if (scrollTop > 100) {
                hasScrolledDown = true;
            }

            // Show sticky nav when scrolling up after scrolling down
            if (hasScrolledDown && scrollTop < lastScrollTop && scrollTop > 1) {
                navContainer.classList.add('nav-sticky');
                navContainer.classList.remove('nav-hidden');
                navContainer.parentElement.classList.add('nav-sticking');
                navLogo.src = stickyLogo;
                if (mobileMenuIcon) {
                    mobileMenuIcon.src = `//addition.life/cdn/shop/t/27/assets/menu-outline.svg?v=163954202466792363961775130023`;
                }
            }
            // Hide nav when scrolling down
            else if (scrollTop > lastScrollTop && scrollTop > 100) {
                navContainer.classList.add('nav-hidden');
            }
            // Reset when at top (with small buffer)
            else if (scrollTop <= 1 && scrollTop > 0) {
                navContainer.classList.remove('nav-sticky', 'nav-hidden');
                navLogo.src = defaultLogo;
                if (mobileMenuIcon) {
                    mobileMenuIcon.src = `//addition.life/cdn/shop/t/27/assets/hamburger-white.svg?v=28940738419301439421775130023`;
                }
                hasScrolledDown = false;
            }

            lastScrollTop = scrollTop;
            ticking = false;
        }

        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(updateNavigation);
                ticking = true;
            }
        }

        window.addEventListener('scroll', requestTick);
    }

    // Mobile Menu Functionality
    const mobileMenuToggle = document.getElementById('mobileMenuToggle');
    const mobileMenu = document.getElementById('mobileMenu');
    const mobileMenuOverlay = document.getElementById('mobileMenuOverlay');
    const mobileMenuClose = document.getElementById('mobileMenuClose');

    if (mobileMenuToggle && mobileMenu && mobileMenuOverlay) {
        function toggleMobileMenu() {
            mobileMenuToggle.classList.toggle('active');
            mobileMenu.classList.toggle('active');
            mobileMenuOverlay.classList.toggle('active');
            document.body.classList.toggle('menu-open');
        }

        function closeMobileMenu() {
            mobileMenuToggle.classList.remove('active');
            mobileMenu.classList.remove('active');
            mobileMenuOverlay.classList.remove('active');
            document.body.classList.remove('menu-open');
        }

        mobileMenuToggle.addEventListener('click', toggleMobileMenu);
        mobileMenuOverlay.addEventListener('click', closeMobileMenu);

        if (mobileMenuClose) {
            mobileMenuClose.addEventListener('click', closeMobileMenu);
        }

        // Close menu when clicking on menu links
        const mobileMenuLinks = mobileMenu.querySelectorAll('a');
        mobileMenuLinks.forEach(link => {
            link.addEventListener('click', closeMobileMenu);
        });

        // Close menu on escape key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && mobileMenu.classList.contains('active')) {
                closeMobileMenu();
            }
        });
    }
}

// Product Filters Functionality
class ProductFilters {
    constructor() {
        this.filtersToggle = document.getElementById('filtersToggle');
        this.filtersSidebar = document.getElementById('filtersSidebar');
        this.filtersClose = document.getElementById('filtersClose');
        this.productsGrid = document.getElementById('productsGrid');
        this.filterOverlay = document.getElementById('filterOverlay');
        this.filterActions = document.querySelectorAll('.filter-btn-action');
        
        this.init();
    }
    
    init() {
        if (this.filtersToggle && this.filtersSidebar) {
            this.filtersToggle.addEventListener('click', () => this.toggleFilters());
        }
        
        if (this.filtersClose) {
            this.filtersClose.addEventListener('click', () => this.closeFilters());
        }

        this.filterActions.forEach(element => {
            element.addEventListener('click', () => this.closeFilters());
        });
        
        // Close filters when clicking overlay
        if (this.filterOverlay) {
            this.filterOverlay.addEventListener('click', () => this.closeFilters());
        }
        
        // Close filters when clicking close button
        const filtersClose = document.getElementById('filtersClose');
        if (filtersClose) {
            filtersClose.addEventListener('click', () => this.closeFilters());
        }
        
        // Initialize collapsible filter sections
        this.initCollapsibleFilters();
        
        // Handle screen resize for overlay management
        this.initResizeHandler();
    }
    
    initCollapsibleFilters() {
        const filterHeaders = document.querySelectorAll('.filter-header');
        filterHeaders.forEach(header => {
            header.addEventListener('click', () => {
                const toggleType = header.getAttribute('data-toggle');
                const content = document.getElementById(toggleType + 'Content');
                const section = header.closest('.filter-section');
                
                if (content) {
                    // Toggle the active class for both section and content
                    section.classList.toggle('active');
                    content.classList.toggle('active');
                }
            });
        });
    }
    
    initResizeHandler() {
        window.addEventListener('resize', () => {
            // Check if filters are currently open
            const filtersOpen = this.filtersSidebar.classList.contains('active');
            
            if (filtersOpen) {
                // Handle overlay based on current screen size
                if (window.innerWidth <= 768) {
                    // Mobile: show overlay and prevent scrolling
                    this.filterOverlay.classList.add('active');
                    document.body.classList.add('filters-open');
                } else {
                    // Desktop: hide overlay and allow scrolling
                    this.filterOverlay.classList.remove('active');
                    document.body.classList.remove('filters-open');
                }
            }
        });
    }
    
    toggleFilters() {
        if (this.filtersSidebar.classList.contains('active')) {
            this.closeFilters();
        } else {
            this.openFilters();
        }
    }
    
    openFilters() {
        this.filtersSidebar.classList.add('active');
        this.productsGrid.classList.add('filters-open');
        this.filtersToggle.classList.add('active');
        
        // Show overlay and prevent body scroll on mobile
        if (window.innerWidth <= 768) {
            this.filterOverlay.classList.add('active');
            document.body.classList.add('filters-open');
        }
        
        // Change button text to "HIDE FILTERS"
        const toggleText = this.filtersToggle.querySelector('.toggle-text');
        if (toggleText) {
            toggleText.textContent = 'Hide Filters';
        }
    }
    
    closeFilters() {
        this.filtersSidebar.classList.remove('active');
        this.productsGrid.classList.remove('filters-open');
        this.filtersToggle.classList.remove('active');
        
        // Hide overlay and re-enable body scroll
        this.filterOverlay.classList.remove('active');
        document.body.classList.remove('filters-open');
        
        // Change button text back to "SHOW FILTERS"
        const toggleText = this.filtersToggle.querySelector('.toggle-text');
        if (toggleText) {
            toggleText.textContent = 'Show Filters';
        }
    }
}